/**
 * iOS Safari zooms the page into any focused field under 16px and does not zoom back out. Phones take
 * `body-lg`'s 16px SIZE only: the line height stays `body-md`'s 20px, because every drawn height in
 * this family counts 20px lines, so the field does not grow and the floating label does not move.
 * Shared by every DS text-entry control: `TextInput` (and `Search`, which reuses its pill),
 * `TextArea`, `DatePicker`, `TimePicker`, `TagInput` and `ChatInput`.
 */
export const PHONE_INPUT_SIZE = 'max-sm:text-[length:var(--ds-type-body-lg-size)]';
